import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const BookletMaterialUpdateSlice = createSlice({
  name: "BookletMaterialUpdateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    bookletMaterialUpdate: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successBookletMaterialUpdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureBookletMaterialUpdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearBookletMaterialUpdate: (state) => {
      state.data = {};
    },
  },
});

export const {
  bookletMaterialUpdate,
  failureBookletMaterialUpdate,
  successBookletMaterialUpdate,
  clearBookletMaterialUpdate,
} = BookletMaterialUpdateSlice.actions;

export default BookletMaterialUpdateSlice.reducer;
